export default function Error({ message, className }) {

  return (
    <div>
      <p className={`error ${className}`}>{message}</p>
    </div>
  );
}
